// Additional countries to be added to mockData.js

export const additionalCountries = [
  {
    id: 'switzerland',
    name: 'Schweiz',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=800',
    avgFlightPrice: 180,
    optimalAirports: [
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 250, avgPrice: '€150', parking: 'Parkos - €65/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 120, avgPrice: '€190', parking: 'Airparks - €42/Woche' },
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 100, avgPrice: '€200', parking: 'Holiday Extras - €45/Woche' }
    ],
    scores: { friendliness: 8.3, easyTravel: 9.8, womenSafety: 9.7, sustainability: 9.2 },
    valueScore: { internetSpeed: '95 Mbps', livingCosts: '€2,500/Monat', rent: '€1,800/Monat', nomadScore: 6.5 },
    optimalTravelTime: { best: 'Juni-September (Sommer), Dezember-März (Ski)', reason: 'Alpenwandern im Sommer, Skifahren im Winter. Sehr teuer in Hochsaison.' },
    weather: [
      { month: 'Jan', temp: '-1°C', rain: '60mm' }, { month: 'Feb', temp: '1°C', rain: '55mm' },
      { month: 'Mär', temp: '6°C', rain: '65mm' }, { month: 'Apr', temp: '10°C', rain: '75mm' },
      { month: 'Mai', temp: '15°C', rain: '95mm' }, { month: 'Jun', temp: '18°C', rain: '110mm' },
      { month: 'Jul', temp: '20°C', rain: '115mm' }, { month: 'Aug', temp: '19°C', rain: '110mm' },
      { month: 'Sep', temp: '16°C', rain: '85mm' }, { month: 'Okt', temp: '11°C', rain: '75mm' },
      { month: 'Nov', temp: '5°C', rain: '70mm' }, { month: 'Dez', temp: '1°C', rain: '65mm' }
    ],
    transportation: [
      { type: 'SBB (Bahn)', cost: '€60-180', speed: 'Sehr schnell', comfort: 'Sehr hoch' },
      { type: 'Mietwagen', cost: '€50-120/Tag', speed: 'Flexibel', comfort: 'Hoch' }
    ],
    noGos: ['Lärm nach 22 Uhr', 'Sonntags Rasenmähen oder laute Arbeiten', 'Müll zur falschen Zeit rausstellen'],
    avgCosts: { coffee: '€4.50', beer: '€6.50', wine: '€7.50', water: '€3.50', localFood: '€20-35', massage: '€95', manicure: '€55', botox: '€400-550', teethWhitening: '€600-900' },
    apps: [{ name: 'SBB Mobile', purpose: 'Bahn & ÖPNV', affiliate: '#' }, { name: 'Twint', purpose: 'Mobile Payment', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Schweiz', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€24.99' }],
    travel_tips: {
      highlights: ["Bern", "Zürich", "Luzern", "Interlaken", "Zermatt"],
      hidden_gems: ["Lötschental statt Jungfraujoch", "Kostenlose Wanderungen am Thuner- & Brienzersee"],
      mobility_tips: [
        "ÖV (SBB) teuer, aber Sparbuchungen früh lohnen",
        "Tages-/Kombitickets für viel Fahren",
        "Kostenlose Wanderungen + günstiger Tages-ÖV-Pass"
      ],
      eating_tips: [
        "Essen in Schweiz generell teuer",
        "Kochen in Ferienwohnung fast immer günstiger",
        "Migros, Coop, Denner für günstige Tages-Mahlzeiten"
      ],
      too_good_to_go: "Aktiv in Zürich, Basel, Genf.",
      entry_requirements: ["Personalausweis oder Reisepass", "Kein Visum bis 90 Tage"],
      international_license_needed: false,
      medication_tips: [],
      birthday_freebies: [
        "FORTYSEVEN Wellness Therme Baden: 3h Gratis an Geburtstag",
        "Viele Hotels/Thermen: eigener Geburtstagstag gratis",
        "Personalausweis vorzeigen, vorab anmelden"
      ]
    }
  },
  {
    id: 'italy',
    name: 'Italien',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=800',
    avgFlightPrice: 120,
    optimalAirports: [
      { name: 'München (MUC)', city: 'München', directFlights: 180, avgPrice: '€110', parking: 'Airparks - €42/Woche' },
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 200, avgPrice: '€130', parking: 'Holiday Extras - €45/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 150, avgPrice: '€140', parking: 'Parkos - €65/Woche' }
    ],
    scores: { friendliness: 9.0, easyTravel: 8.5, womenSafety: 8.3, sustainability: 7.5 },
    valueScore: { internetSpeed: '70 Mbps', livingCosts: '€1,000/Monat', rent: '€700/Monat', nomadScore: 8.0 },
    optimalTravelTime: { best: 'April-Juni & September-Oktober', reason: 'Mildes Wetter, weniger Touristen. Vermeide Juli-August (überfüllt & heiß).' },
    weather: [
      { month: 'Jan', temp: '8°C', rain: '70mm' }, { month: 'Feb', temp: '9°C', rain: '65mm' },
      { month: 'Mär', temp: '12°C', rain: '60mm' }, { month: 'Apr', temp: '16°C', rain: '55mm' },
      { month: 'Mai', temp: '21°C', rain: '50mm' }, { month: 'Jun', temp: '25°C', rain: '40mm' },
      { month: 'Jul', temp: '28°C', rain: '25mm' }, { month: 'Aug', temp: '28°C', rain: '30mm' },
      { month: 'Sep', temp: '24°C', rain: '60mm' }, { month: 'Okt', temp: '19°C', rain: '90mm' },
      { month: 'Nov', temp: '13°C', rain: '95mm' }, { month: 'Dez', temp: '9°C', rain: '80mm' }
    ],
    transportation: [
      { type: 'Trenitalia (Bahn)', cost: '€30-100', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'FlixBus', cost: '€10-35', speed: 'Mittel', comfort: 'Mittel' },
      { type: 'Roller-Miete', cost: '€20-40/Tag', speed: 'Flexibel', comfort: 'Niedrig' }
    ],
    noGos: ['Cappuccino nach 11 Uhr bestellen', 'Pineapple auf Pizza erwähnen', 'In Kirchen mit kurzen Hosen'],
    avgCosts: { coffee: '€1.50', beer: '€4.50', wine: '€4.00', water: '€1.50', localFood: '€10-20', massage: '€50', manicure: '€25', botox: '€250-350', teethWhitening: '€300-450' },
    apps: [{ name: 'Trenitalia', purpose: 'Bahntickets', affiliate: '#' }, { name: 'TheFork', purpose: 'Restaurants', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Italien', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€26.99' }],
    travel_tips: {
      highlights: ["Rom", "Venedig", "Florenz", "Mailand", "Amalfiküste", "Sizilien"],
      hidden_gems: ["Matera", "Civita di Bagnoregio", "Umbrien", "Calabrien", "Puglia"],
      mobility_tips: [
        "Lokale Supermärkte (Lidl, Carrefour, Coop) für Basics",
        "Restaurants in Nebenstraßen halb so teuer"
      ],
      eating_tips: [
        "Kochen in Ferienwohnungen günstig",
        "Einfache Restaurants außerhalb Touristenplätze deutlich günstiger"
      ],
      too_good_to_go: "Aktiv in Rom, Mailand, Florenz, Bologna bei Bäckereien, Cafés.",
      entry_requirements: ["Personalausweis oder Reisepass"],
      international_license_needed: false,
      medication_tips: [
        "Mückenschutz im Süden (Sizilien) im Sommer sinnvoll",
        "Deutsche Drogerien günstiger für Sonnencreme"
      ],
      birthday_freebies: [
        "Einige Pizzaketten: Gratis-Getränk oder kleine Pizza",
        "Museen in kleineren Städten: Gratis-Eintritt an Geburtstag",
        "Newsletter vor Reise anmelden"
      ]
    }
  },
  {
    id: 'portugal',
    name: 'Portugal',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=800',
    avgFlightPrice: 160,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 85, avgPrice: '€150', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 60, avgPrice: '€170', parking: 'Airparks - €42/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 45, avgPrice: '€180', parking: 'Parkos - €65/Woche' }
    ],
    scores: { friendliness: 9.3, easyTravel: 8.7, womenSafety: 8.8, sustainability: 8.0 },
    valueScore: { internetSpeed: '80 Mbps', livingCosts: '€900/Monat', rent: '€650/Monat', nomadScore: 8.8 },
    optimalTravelTime: { best: 'März-Mai & September-Oktober', reason: 'Perfektes Wetter, günstigere Preise. Lissabon & Porto ideal im Frühling/Herbst.' },
    weather: [
      { month: 'Jan', temp: '11°C', rain: '110mm' }, { month: 'Feb', temp: '12°C', rain: '100mm' },
      { month: 'Mär', temp: '14°C', rain: '70mm' }, { month: 'Apr', temp: '16°C', rain: '60mm' },
      { month: 'Mai', temp: '19°C', rain: '40mm' }, { month: 'Jun', temp: '22°C', rain: '15mm' },
      { month: 'Jul', temp: '25°C', rain: '5mm' }, { month: 'Aug', temp: '25°C', rain: '10mm' },
      { month: 'Sep', temp: '23°C', rain: '30mm' }, { month: 'Okt', temp: '19°C', rain: '80mm' },
      { month: 'Nov', temp: '15°C', rain: '110mm' }, { month: 'Dez', temp: '12°C', rain: '120mm' }
    ],
    transportation: [
      { type: 'Metro/ÖPNV', cost: '€1.50-2.50', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'Bolt/Uber', cost: '€5-15', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'Mietwagen', cost: '€25-50/Tag', speed: 'Flexibel', comfort: 'Hoch' }
    ],
    noGos: ['Portugal mit Spanien verwechseln', 'Nur Spanisch sprechen', 'Trinkgeld vergessen (5-10%)'],
    avgCosts: { coffee: '€0.80', beer: '€2.00', wine: '€3.50', water: '€0.60', localFood: '€8-15', massage: '€40', manicure: '€20', botox: '€200-300', teethWhitening: '€250-400' },
    apps: [{ name: 'Moovit', purpose: 'ÖPNV Navigation', affiliate: '#' }, { name: 'Bolt', purpose: 'Transport', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Portugal', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€21.99' }],
    travel_tips: {
      highlights: ["Lissabon", "Porto", "Algarve", "Funchal (Madeira)", "Azoren"],
      hidden_gems: ["Coimbra", "Aveiro", "Sintra-Natur", "Kleine Fischerdörfer"],
      mobility_tips: [
        "Günstig per FlixBus aus Spanien oder Billig-Airlines",
        "Günstiger Bus- bzw. Regionalzug-Vergleich"
      ],
      eating_tips: [
        "In Städten günstiger als Deutschland",
        "Viele kleine 'Tascas' mit Tages-Menüs",
        "Lokales Essen oft günstiger als Kochen"
      ],
      too_good_to_go: "Aktiv in Lissabon und Porto bei Bäckereien, Cafés.",
      entry_requirements: ["Personalausweis oder Reisepass"],
      international_license_needed: false,
      medication_tips: [],
      birthday_freebies: [
        "Lissabon: Escape-Rooms, Mini-Adventure-Parks bieten Gratis-Eintritte",
        "Bars/Cafés: Gratis-Getränk oder Snacks auf Anfrage"
      ]
    }
  },
  {
    id: 'poland',
    name: 'Polen',
    continent: 'Europa',
    image: 'https://images.pexels.com/photos/32031418/pexels-photo-32031418.jpeg?auto=compress&cs=tinysrgb&w=800',
    avgFlightPrice: 110,
    optimalAirports: [
      { name: 'Berlin (BER)', city: 'Berlin', directFlights: 120, avgPrice: '€90', parking: 'ParkVia - €38/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 80, avgPrice: '€120', parking: 'Airparks - €42/Woche' },
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 90, avgPrice: '€115', parking: 'Holiday Extras - €45/Woche' }
    ],
    scores: { friendliness: 8.7, easyTravel: 8.5, womenSafety: 8.6, sustainability: 7.6 },
    valueScore: { internetSpeed: '75 Mbps', livingCosts: '€700/Monat', rent: '€450/Monat', nomadScore: 8.4 },
    optimalTravelTime: { best: 'Mai-September', reason: 'Warmes Wetter, lange Tage. Krakau & Warschau perfekt im Sommer.' },
    weather: [
      { month: 'Jan', temp: '-2°C', rain: '30mm' }, { month: 'Feb', temp: '0°C', rain: '28mm' },
      { month: 'Mär', temp: '5°C', rain: '32mm' }, { month: 'Apr', temp: '11°C', rain: '38mm' },
      { month: 'Mai', temp: '17°C', rain: '55mm' }, { month: 'Jun', temp: '20°C', rain: '65mm' },
      { month: 'Jul', temp: '22°C', rain: '70mm' }, { month: 'Aug', temp: '22°C', rain: '65mm' },
      { month: 'Sep', temp: '17°C', rain: '45mm' }, { month: 'Okt', temp: '12°C', rain: '40mm' },
      { month: 'Nov', temp: '6°C', rain: '38mm' }, { month: 'Dez', temp: '1°C', rain: '35mm' }
    ],
    transportation: [
      { type: 'ÖPNV', cost: '€0.80-1.50', speed: 'Schnell', comfort: 'Mittel' },
      { type: 'Bolt', cost: '€3-10', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'Bahn (PKP)', cost: '€10-30', speed: 'Mittel', comfort: 'Mittel' }
    ],
    noGos: ['Russland-Polen Geschichte ansprechen', 'Vodka ablehnen', 'WWII-Witze'],
    avgCosts: { coffee: '€2.50', beer: '€2.50', wine: '€4.00', water: '€1.00', localFood: '€6-12', massage: '€30', manicure: '€15', botox: '€150-220', teethWhitening: '€180-300' },
    apps: [{ name: 'Jakdojade', purpose: 'ÖPNV', affiliate: '#' }, { name: 'Bolt', purpose: 'Transport', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Polen', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€22.99' }],
    travel_tips: {
      highlights: ["Krakau", "Warschau", "Danzig", "Lublin", "Masurische Seenkette"],
      hidden_gems: ["Kleine Städte entlang der Weichsel", "Seen-Regionen"],
      mobility_tips: [
        "Günstig per FlixBus oder Regio-Zug aus Deutschland",
        "Innerhalb Polens sind Regionalzüge und Busse sehr kostengünstig"
      ],
      eating_tips: [
        "Krakau und Warschau günstig außerhalb Touristen-Hotspots",
        "Lokale 'schabowski'-Lokale, Bäckereien sehr günstig"
      ],
      too_good_to_go: "Aktiv in Krakau, Warschau, Wrocław, Poznań, Gdansk.",
      entry_requirements: ["Personalausweis oder Reisepass", "Kein Visum, Aufenthalt bis 90 Tage"],
      international_license_needed: false,
      medication_tips: [],
      birthday_freebies: [
        "Krakau: Hotels, Apartments, Escape-Rooms bieten Geburtstagspakete",
        "Einzelne Bars: Gratis-Getränk oder Snacks auf Anfrage"
      ]
    }
  },
  {
    id: 'dubai',
    name: 'Dubai (VAE)',
    continent: 'Asien',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=800',
    avgFlightPrice: 380,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 65, avgPrice: '€370', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 55, avgPrice: '€390', parking: 'Airparks - €42/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 45, avgPrice: '€400', parking: 'Parkos - €65/Woche' }
    ],
    scores: { friendliness: 8.5, easyTravel: 9.0, womenSafety: 9.0, sustainability: 6.0 },
    valueScore: { internetSpeed: '140 Mbps', livingCosts: '€2,000/Monat', rent: '€1,400/Monat', nomadScore: 7.2 },
    optimalTravelTime: { best: 'November-März', reason: 'Angenehme Temperaturen 20-30°C. Vermeide Juni-September (extrem heiß 40-50°C).' },
    weather: [
      { month: 'Jan', temp: '20°C', rain: '15mm' }, { month: 'Feb', temp: '21°C', rain: '25mm' },
      { month: 'Mär', temp: '24°C', rain: '20mm' }, { month: 'Apr', temp: '28°C', rain: '5mm' },
      { month: 'Mai', temp: '33°C', rain: '0mm' }, { month: 'Jun', temp: '36°C', rain: '0mm' },
      { month: 'Jul', temp: '38°C', rain: '0mm' }, { month: 'Aug', temp: '38°C', rain: '0mm' },
      { month: 'Sep', temp: '35°C', rain: '0mm' }, { month: 'Okt', temp: '31°C', rain: '0mm' },
      { month: 'Nov', temp: '26°C', rain: '5mm' }, { month: 'Dez', temp: '22°C', rain: '15mm' }
    ],
    transportation: [
      { type: 'Metro', cost: '€1.50-3', speed: 'Sehr schnell', comfort: 'Sehr hoch' },
      { type: 'Careem/Uber', cost: '€5-20', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'Taxi', cost: '€8-25', speed: 'Schnell', comfort: 'Hoch' }
    ],
    noGos: ['Alkohol in der Öffentlichkeit', 'Zuneigung in der Öffentlichkeit', 'Schultern & Knie unbedeckt', 'Kritik an Regierung', 'Fotografieren von Regierungsgebäuden'],
    avgCosts: { coffee: '€5.00', beer: '€10.00', wine: '€12.00', water: '€0.50', localFood: '€8-15', massage: '€80', manicure: '€40', botox: '€250-400', teethWhitening: '€400-600' },
    apps: [{ name: 'Careem', purpose: 'Transport', affiliate: '#' }, { name: 'Entertainer', purpose: 'Deals & Rabatte', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Dubai & Abu Dhabi', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€18.99' }]
  },
  {
    id: 'india',
    name: 'Indien',
    continent: 'Asien',
    image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=800',
    avgFlightPrice: 480,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 55, avgPrice: '€460', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 42, avgPrice: '€490', parking: 'Airparks - €42/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 35, avgPrice: '€510', parking: 'Parkos - €65/Woche' }
    ],
    scores: { friendliness: 9.0, easyTravel: 6.5, womenSafety: 6.5, sustainability: 5.5 },
    valueScore: { internetSpeed: '50 Mbps', livingCosts: '€450/Monat', rent: '€250/Monat', nomadScore: 8.2 },
    optimalTravelTime: { best: 'Oktober-März', reason: 'Kühlere Temperaturen, weniger Monsun. Nord: Nov-Feb, Süd: Dez-Feb ideal.' },
    weather: [
      { month: 'Jan', temp: '14°C', rain: '20mm' }, { month: 'Feb', temp: '17°C', rain: '18mm' },
      { month: 'Mär', temp: '23°C', rain: '15mm' }, { month: 'Apr', temp: '28°C', rain: '12mm' },
      { month: 'Mai', temp: '33°C', rain: '30mm' }, { month: 'Jun', temp: '33°C', rain: '75mm' },
      { month: 'Jul', temp: '31°C', rain: '210mm' }, { month: 'Aug', temp: '30°C', rain: '250mm' },
      { month: 'Sep', temp: '29°C', rain: '170mm' }, { month: 'Okt', temp: '28°C', rain: '60mm' },
      { month: 'Nov', temp: '23°C', rain: '10mm' }, { month: 'Dez', temp: '17°C', rain: '10mm' }
    ],
    transportation: [
      { type: 'Auto-Rickshaw', cost: '€0.50-2', speed: 'Langsam', comfort: 'Niedrig' },
      { type: 'Uber/Ola', cost: '€2-8', speed: 'Mittel', comfort: 'Mittel' },
      { type: 'Zug', cost: '€5-30', speed: 'Langsam', comfort: 'Niedrig-Mittel' },
      { type: 'Inlandsflug', cost: '€30-80', speed: 'Schnell', comfort: 'Hoch' }
    ],
    noGos: ['Mit linker Hand essen', 'Kopf berühren', 'Füße auf Personen richten', 'Kühe als Nutztiere bezeichnen', 'In Tempeln unbedeckte Schultern'],
    avgCosts: { coffee: '€1.20', beer: '€2.50', wine: '€8.00', water: '€0.20', localFood: '€1.00-3.00', massage: '€8', manicure: '€5', botox: '€80-150', teethWhitening: '€100-200' },
    apps: [{ name: 'Ola', purpose: 'Transport', affiliate: '#' }, { name: 'Swiggy', purpose: 'Food Delivery', affiliate: '#' }, { name: 'Paytm', purpose: 'Payment', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Indien', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€28.99' }]
  },
  {
    id: 'hongkong',
    name: 'Hong Kong',
    continent: 'Asien',
    image: 'https://images.unsplash.com/photo-1536599018102-9f803c140fc1?w=800',
    avgFlightPrice: 580,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 35, avgPrice: '€560', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 25, avgPrice: '€590', parking: 'Airparks - €42/Woche' },
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 20, avgPrice: '€610', parking: 'Parkos - €65/Woche' }
    ],
    scores: { friendliness: 8.0, easyTravel: 9.5, womenSafety: 9.2, sustainability: 7.5 },
    valueScore: { internetSpeed: '210 Mbps', livingCosts: '€2,500/Monat', rent: '€2,000/Monat', nomadScore: 7.0 },
    optimalTravelTime: { best: 'Oktober-Dezember', reason: 'Angenehme Temperaturen, wenig Regen. Vermeide Mai-September (heiß & feucht).' },
    weather: [
      { month: 'Jan', temp: '16°C', rain: '25mm' }, { month: 'Feb', temp: '17°C', rain: '55mm' },
      { month: 'Mär', temp: '19°C', rain: '75mm' }, { month: 'Apr', temp: '23°C', rain: '175mm' },
      { month: 'Mai', temp: '27°C', rain: '290mm' }, { month: 'Jun', temp: '29°C', rain: '455mm' },
      { month: 'Jul', temp: '29°C', rain: '385mm' }, { month: 'Aug', temp: '29°C', rain: '430mm' },
      { month: 'Sep', temp: '28°C', rain: '295mm' }, { month: 'Okt', temp: '26°C', rain: '100mm' },
      { month: 'Nov', temp: '22°C', rain: '35mm' }, { month: 'Dez', temp: '18°C', rain: '25mm' }
    ],
    transportation: [
      { type: 'MTR (Metro)', cost: '€1-3', speed: 'Sehr schnell', comfort: 'Sehr hoch' },
      { type: 'Tram', cost: '€0.30', speed: 'Langsam', comfort: 'Mittel' },
      { type: 'Taxi', cost: '€5-20', speed: 'Mittel', comfort: 'Hoch' },
      { type: 'Fähre', cost: '€0.40', speed: 'Mittel', comfort: 'Hoch' }
    ],
    noGos: ['Trinkgeld geben (unhöflich)', 'Stäbchen in Reis stecken', 'Laut sein in ÖPNV', 'Politik diskutieren'],
    avgCosts: { coffee: '€4.00', beer: '€6.00', wine: '€8.00', water: '€1.00', localFood: '€4-10', massage: '€40', manicure: '€20', botox: '€200-350', teethWhitening: '€300-500' },
    apps: [{ name: 'MTR Mobile', purpose: 'ÖPNV', affiliate: '#' }, { name: 'OpenRice', purpose: 'Restaurants', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Hong Kong', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€17.99' }]
  },
  {
    id: 'taiwan',
    name: 'Taiwan',
    continent: 'Asien',
    image: 'https://images.unsplash.com/photo-1601534621622-8587a8a0da11?w=800',
    avgFlightPrice: 620,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 28, avgPrice: '€600', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 18, avgPrice: '€630', parking: 'Airparks - €42/Woche' },
      { name: 'Wien (VIE)', city: 'Wien', directFlights: 22, avgPrice: '€640', parking: 'Parkos - €48/Woche' }
    ],
    scores: { friendliness: 9.5, easyTravel: 9.0, womenSafety: 9.5, sustainability: 8.5 },
    valueScore: { internetSpeed: '130 Mbps', livingCosts: '€900/Monat', rent: '€600/Monat', nomadScore: 8.9 },
    optimalTravelTime: { best: 'Oktober-Dezember & März-Mai', reason: 'Angenehme Temperaturen, weniger Taifune. Kirschblüte im März.' },
    weather: [
      { month: 'Jan', temp: '16°C', rain: '85mm' }, { month: 'Feb', temp: '17°C', rain: '135mm' },
      { month: 'Mär', temp: '19°C', rain: '150mm' }, { month: 'Apr', temp: '23°C', rain: '155mm' },
      { month: 'Mai', temp: '26°C', rain: '250mm' }, { month: 'Jun', temp: '28°C', rain: '325mm' },
      { month: 'Jul', temp: '30°C', rain: '245mm' }, { month: 'Aug', temp: '29°C', rain: '290mm' },
      { month: 'Sep', temp: '28°C', rain: '250mm' }, { month: 'Okt', temp: '25°C', rain: '115mm' },
      { month: 'Nov', temp: '22°C', rain: '75mm' }, { month: 'Dez', temp: '18°C', rain: '70mm' }
    ],
    transportation: [
      { type: 'MRT (Metro)', cost: '€0.60-1.50', speed: 'Sehr schnell', comfort: 'Sehr hoch' },
      { type: 'Bus', cost: '€0.50-1', speed: 'Mittel', comfort: 'Hoch' },
      { type: 'Roller-Miete', cost: '€8-15/Tag', speed: 'Flexibel', comfort: 'Mittel' },
      { type: 'HSR (Hochgeschwindigkeitszug)', cost: '€15-45', speed: 'Sehr schnell', comfort: 'Sehr hoch' }
    ],
    noGos: ['Taiwan als Teil Chinas bezeichnen', 'Mit Stäbchen zeigen', 'Schuhe in Wohnungen anlassen'],
    avgCosts: { coffee: '€2.50', beer: '€2.00', wine: '€8.00', water: '€0.40', localFood: '€2-6', massage: '€20', manicure: '€12', botox: '€150-250', teethWhitening: '€200-350' },
    apps: [{ name: 'EasyCard', purpose: 'ÖPNV Payment', affiliate: '#' }, { name: 'Foodpanda', purpose: 'Food Delivery', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Taiwan', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€21.99' }]
  },
  {
    id: 'liechtenstein',
    name: 'Liechtenstein',
    continent: 'Europa',
    image: 'https://customer-assets.emergentagent.com/job_nomad-journey-hub/artifacts/yh2c0vgz_Liechtenstein.JPG',
    avgFlightPrice: 200,
    optimalAirports: [
      { name: 'Zürich (ZRH)', city: 'Zürich', directFlights: 250, avgPrice: '€180', parking: 'Parkos - €65/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 120, avgPrice: '€210', parking: 'Airparks - €42/Woche' }
    ],
    scores: { friendliness: 8.8, easyTravel: 9.2, womenSafety: 9.8, sustainability: 9.0 },
    valueScore: { internetSpeed: '100 Mbps', livingCosts: '€2,800/Monat', rent: '€2,000/Monat', nomadScore: 6.0 },
    optimalTravelTime: { best: 'Juni-September', reason: 'Kleines Fürstentum perfekt für Wandern und Radfahren im Sommer.' },
    weather: [
      { month: 'Jan', temp: '-2°C', rain: '55mm' }, { month: 'Feb', temp: '0°C', rain: '50mm' },
      { month: 'Mär', temp: '5°C', rain: '60mm' }, { month: 'Apr', temp: '9°C', rain: '70mm' },
      { month: 'Mai', temp: '14°C', rain: '90mm' }, { month: 'Jun', temp: '17°C', rain: '105mm' },
      { month: 'Jul', temp: '19°C', rain: '110mm' }, { month: 'Aug', temp: '18°C', rain: '105mm' },
      { month: 'Sep', temp: '15°C', rain: '80mm' }, { month: 'Okt', temp: '10°C', rain: '70mm' },
      { month: 'Nov', temp: '4°C', rain: '65mm' }, { month: 'Dez', temp: '0°C', rain: '60mm' }
    ],
    transportation: [
      { type: 'Bus (LIEmobil)', cost: '€5-15', speed: 'Mittel', comfort: 'Hoch' },
      { type: 'Fahrrad-Miete', cost: '€20/Tag', speed: 'Langsam', comfort: 'Mittel' }
    ],
    noGos: ['Laute Musik', 'Unsauberkeit', 'Sonntagsarbeiten'],
    avgCosts: { coffee: '€4.50', beer: '€6.00', wine: '€7.00', water: '€3.00', localFood: '€18-30', massage: '€90', manicure: '€50', botox: '€400-550', teethWhitening: '€600-850' },
    apps: [{ name: 'LIEmobil', purpose: 'Öffentlicher Verkehr', affiliate: '#' }],
    travelGuides: [{ title: 'Reiseführer Liechtenstein', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€14.99' }],
    travel_tips: {
      highlights: ["Vaduz", "Schloss (Außenansicht)", "Rheinpromenade"],
      hidden_gems: ["Gampriner Seele", "Valüna-Wanderungen", "Kostenlose Bergwege"],
      mobility_tips: [
        "Zug aus Deutschland/Österreich → Bus in Liechtenstein",
        "Autofahren wegen Parkplätzen & Benzin teuer"
      ],
      eating_tips: [
        "Kochen in Ferienwohnung deutlich günstiger",
        "Migros, Coop, Denner für Ready-Mahlzeiten"
      ],
      too_good_to_go: "Nicht aktiv in Liechtenstein.",
      entry_requirements: ["Personalausweis oder Reisepass", "Kein Visum für EU-Bürger"],
      international_license_needed: false,
      medication_tips: [
        "Mückenschutz & Sonnencreme teurer",
        "Besser vorher in Deutschland kaufen"
      ],
      birthday_freebies: ["Keine offiziellen Angebote bekannt"]
    }
  },
  {
    id: 'hungary',
    name: 'Ungarn',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1541963463532-d68292c34b19?w=800',
    avgFlightPrice: 100,
    optimalAirports: [
      { name: 'München (MUC)', city: 'München', directFlights: 80, avgPrice: '€90', parking: 'Airparks - €42/Woche' },
      { name: 'Wien (VIE)', city: 'Wien', directFlights: 120, avgPrice: '€110', parking: 'ParkVia - €35/Woche' }
    ],
    scores: { friendliness: 7.8, easyTravel: 8.3, womenSafety: 8.5, sustainability: 7.2 },
    valueScore: { internetSpeed: '75 Mbps', livingCosts: '€700/Monat', rent: '€450/Monat', nomadScore: 8.5 },
    optimalTravelTime: { best: 'April-Juni & September-Oktober', reason: 'Mildes Wetter, perfekt für Thermalbäder. Budapest im Frühling/Herbst ideal.' },
    weather: [
      { month: 'Jan', temp: '0°C', rain: '35mm' }, { month: 'Feb', temp: '3°C', rain: '30mm' },
      { month: 'Mär', temp: '8°C', rain: '35mm' }, { month: 'Apr', temp: '14°C', rain: '45mm' },
      { month: 'Mai', temp: '19°C', rain: '55mm' }, { month: 'Jun', temp: '22°C', rain: '65mm' },
      { month: 'Jul', temp: '24°C', rain: '50mm' }, { month: 'Aug', temp: '24°C', rain: '45mm' },
      { month: 'Sep', temp: '20°C', rain: '40mm' }, { month: 'Okt', temp: '14°C', rain: '35mm' },
      { month: 'Nov', temp: '7°C', rain: '45mm' }, { month: 'Dez', temp: '2°C', rain: '40mm' }
    ],
    transportation: [
      { type: 'BKK (Budapest)', cost: '€5-15', speed: 'Schnell', comfort: 'Mittel' },
      { type: 'FlixBus', cost: '€8-25', speed: 'Mittel', comfort: 'Mittel' }
    ],
    noGos: ['Trianon-Vertrag erwähnen', 'Ungarn als Osteuropa bezeichnen', 'Politik diskutieren'],
    avgCosts: { coffee: '€1.50', beer: '€1.80', wine: '€2.50', water: '€0.80', localFood: '€5-12', massage: '€25', manicure: '€15', botox: '€150-250', teethWhitening: '€200-350' },
    apps: [{ name: 'BKK Futár', purpose: 'ÖPNV Budapest', affiliate: '#' }, { name: 'Bolt', purpose: 'Transport', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Ungarn', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€21.99' }],
    travel_tips: {
      highlights: ['Budapest', 'Eger', 'Pécs', 'Tokaj'],
      hidden_gems: ['Kleine Städte der Donau-Route', 'Thermalbäder außerhalb Hauptstadt'],
      mobility_tips: ['FlixBus günstig', 'Innerhalb Ungarns günstiger Regionalverkehr'],
      eating_tips: ['Gulasch-Lokale sehr günstig', 'CBA, Aldi, Lidl günstig'],
      too_good_to_go: "Nicht in Ungarn aktiv.",
      entry_requirements: ['Personalausweis oder Reisepass'],
      international_license_needed: false,
      medication_tips: [],
      birthday_freebies: ['Budapest: Einige Bars bieten Gratis-Eintritte']
    }
  },
  {
    id: 'czechia',
    name: 'Tschechien',
    continent: 'Europa',
    image: 'https://images.unsplash.com/photo-1541849546-216549ae216d?w=800',
    avgFlightPrice: 95,
    optimalAirports: [
      { name: 'München (MUC)', city: 'München', directFlights: 90, avgPrice: '€85', parking: 'Airparks - €42/Woche' },
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 70, avgPrice: '€105', parking: 'Holiday Extras - €45/Woche' }
    ],
    scores: { friendliness: 8.0, easyTravel: 8.8, womenSafety: 8.7, sustainability: 7.8 },
    valueScore: { internetSpeed: '80 Mbps', livingCosts: '€750/Monat', rent: '€500/Monat', nomadScore: 8.3 },
    optimalTravelTime: { best: 'April-Juni & September-Oktober', reason: 'Prag ohne Massen, Wandern in Böhmen. Winter für Weihnachtsmärkte.' },
    weather: [
      { month: 'Jan', temp: '-1°C', rain: '25mm' }, { month: 'Feb', temp: '1°C', rain: '22mm' },
      { month: 'Mär', temp: '6°C', rain: '28mm' }, { month: 'Apr', temp: '11°C', rain: '35mm' },
      { month: 'Mai', temp: '16°C', rain: '55mm' }, { month: 'Jun', temp: '19°C', rain: '65mm' },
      { month: 'Jul', temp: '21°C', rain: '70mm' }, { month: 'Aug', temp: '21°C', rain: '60mm' },
      { month: 'Sep', temp: '17°C', rain: '40mm' }, { month: 'Okt', temp: '11°C', rain: '30mm' },
      { month: 'Nov', temp: '5°C', rain: '35mm' }, { month: 'Dez', temp: '1°C', rain: '28mm' }
    ],
    transportation: [
      { type: 'RegioJet (Bahn)', cost: '€10-30', speed: 'Schnell', comfort: 'Hoch' },
      { type: 'FlixBus', cost: '€8-20', speed: 'Mittel', comfort: 'Mittel' },
      { type: 'Prag ÖPNV', cost: '€5-15', speed: 'Schnell', comfort: 'Hoch' }
    ],
    noGos: ['Tschechoslowakei sagen', 'Nur Prag besuchen (Rest ist toll!)', 'Leitungswasser ablehnen'],
    avgCosts: { coffee: '€2.00', beer: '€1.50', wine: '€3.00', water: '€1.00', localFood: '€6-12', massage: '€30', manicure: '€18', botox: '€180-280', teethWhitening: '€250-400' },
    apps: [{ name: 'PID Lítačka', purpose: 'Prag ÖPNV', affiliate: '#' }, { name: 'Bolt', purpose: 'Transport', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Tschechien', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€21.99' }],
    travel_tips: {
      highlights: ['Prag', 'Brünn', 'Český Krumlov', 'Kutná Hora'],
      hidden_gems: ['Tábor', 'Kleinere Städte entlang der Moldau'],
      mobility_tips: ['ÖPNV in Prag günstig'],
      eating_tips: ['Tagesmenü preiswert', 'Frühstück selbst kaufen meist günstigster Weg'],
      too_good_to_go: "Nicht in Tschechien verfügbar.",
      entry_requirements: ['Personalausweis oder Reisepass'],
      international_license_needed: false,
      medication_tips: [],
      birthday_freebies: ['Prag: Einige Bars bieten Geburtstagsrabatte']
    }
  },
  {
    id: 'bosnia',
    name: 'Bosnien und Herzegowina',
    continent: 'Europa',
    image: 'https://images.pexels.com/photos/33660903/pexels-photo-33660903.jpeg?auto=compress&cs=tinysrgb&w=800',
    avgFlightPrice: 140,
    optimalAirports: [
      { name: 'München (MUC)', city: 'München', directFlights: 40, avgPrice: '€130', parking: 'Airparks - €42/Woche' },
      { name: 'Wien (VIE)', city: 'Wien', directFlights: 55, avgPrice: '€150', parking: 'ParkVia - €35/Woche' }
    ],
    scores: { friendliness: 9.0, easyTravel: 7.5, womenSafety: 7.8, sustainability: 6.5 },
    valueScore: { internetSpeed: '50 Mbps', livingCosts: '€500/Monat', rent: '€300/Monat', nomadScore: 7.5 },
    optimalTravelTime: { best: 'Mai-September', reason: 'Wandern, Rafting, Kulturentdeckung. Sarajevo ganzjährig spannend.' },
    weather: [
      { month: 'Jan', temp: '0°C', rain: '65mm' }, { month: 'Feb', temp: '3°C', rain: '60mm' },
      { month: 'Mär', temp: '8°C', rain: '65mm' }, { month: 'Apr', temp: '13°C', rain: '70mm' },
      { month: 'Mai', temp: '18°C', rain: '75mm' }, { month: 'Jun', temp: '21°C', rain: '80mm' },
      { month: 'Jul', temp: '24°C', rain: '65mm' }, { month: 'Aug', temp: '24°C', rain: '60mm' },
      { month: 'Sep', temp: '19°C', rain: '75mm' }, { month: 'Okt', temp: '14°C', rain: '80mm' },
      { month: 'Nov', temp: '7°C', rain: '85mm' }, { month: 'Dez', temp: '2°C', rain: '75mm' }
    ],
    transportation: [
      { type: 'Bus (Intercity)', cost: '€5-20', speed: 'Langsam', comfort: 'Niedrig' },
      { type: 'Mietwagen', cost: '€20-40/Tag', speed: 'Flexibel', comfort: 'Mittel' }
    ],
    noGos: ['Kriegsthemen ansprechen', 'Nationalität/Religion diskutieren', 'Minen-Warnschilder ignorieren'],
    avgCosts: { coffee: '€1.00', beer: '€1.50', wine: '€2.50', water: '€0.50', localFood: '€4-10', massage: '€20', manicure: '€12', botox: '€120-200', teethWhitening: '€150-300' },
    apps: [{ name: 'Centrotrans', purpose: 'Bus-Tickets', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Westbalkan', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€23.99' }],
    travel_tips: {
      highlights: ['Mostar', 'Sarajevo', 'Blagaj', 'Počitelj'],
      hidden_gems: ['Freie Wanderungen in der Natur'],
      mobility_tips: ['ÖPNV sehr billig', 'Busse extrem günstig'],
      eating_tips: ['Essen extrem günstig', 'Burek-Lokale perfekt'],
      too_good_to_go: "Nicht in Bosnien aktiv.",
      entry_requirements: ['Personalausweis/Reisepass', 'Bis 90 Tage kostenlos'],
      international_license_needed: false,
      medication_tips: [],
      birthday_freebies: ['Keine organisierten Angebote']
    }
  },
  {
    id: 'tenerife',
    name: 'Teneriffa',
    continent: 'Europa',
    image: 'https://images.pexels.com/photos/10550307/pexels-photo-10550307.jpeg?auto=compress&cs=tinysrgb&w=800',
    avgFlightPrice: 180,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 120, avgPrice: '€160', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 90, avgPrice: '€190', parking: 'Airparks - €42/Woche' }
    ],
    scores: { friendliness: 8.8, easyTravel: 9.0, womenSafety: 8.9, sustainability: 7.5 },
    valueScore: { internetSpeed: '70 Mbps', livingCosts: '€1,100/Monat', rent: '€750/Monat', nomadScore: 8.5 },
    optimalTravelTime: { best: 'Ganzjährig', reason: 'Ewiger Frühling! 20-25°C das ganze Jahr. Dezember-März für Wal-Beobachtung.' },
    weather: [
      { month: 'Jan', temp: '17°C', rain: '35mm' }, { month: 'Feb', temp: '17°C', rain: '30mm' },
      { month: 'Mär', temp: '18°C', rain: '25mm' }, { month: 'Apr', temp: '19°C', rain: '15mm' },
      { month: 'Mai', temp: '20°C', rain: '5mm' }, { month: 'Jun', temp: '22°C', rain: '2mm' },
      { month: 'Jul', temp: '24°C', rain: '1mm' }, { month: 'Aug', temp: '25°C', rain: '1mm' },
      { month: 'Sep', temp: '24°C', rain: '5mm' }, { month: 'Okt', temp: '22°C', rain: '15mm' },
      { month: 'Nov', temp: '20°C', rain: '25mm' }, { month: 'Dez', temp: '18°C', rain: '35mm' }
    ],
    transportation: [
      { type: 'TITSA (Bus)', cost: '€10-25', speed: 'Langsam', comfort: 'Mittel' },
      { type: 'Mietwagen', cost: '€25-45/Tag', speed: 'Flexibel', comfort: 'Hoch' }
    ],
    noGos: ['Kanaren = Afrika sagen', 'Strand im Norden erwarten', 'Siesta-Zeit stören'],
    avgCosts: { coffee: '€1.50', beer: '€2.00', wine: '€3.00', water: '€1.00', localFood: '€8-15', massage: '€40', manicure: '€20', botox: '€200-300', teethWhitening: '€300-450' },
    apps: [{ name: 'TITSA', purpose: 'Bus-Tickets', affiliate: '#' }, { name: 'Cabify', purpose: 'Transport', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Kanarische Inseln', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€19.99' }],
    travel_tips: {
      highlights: ['Teide', 'Masca', 'Los Gigantes', 'Santa Cruz'],
      hidden_gems: ['Anaga-Gebirge', 'Garachico'],
      mobility_tips: ['TITSA Bus günstig', 'Mietwagen empfohlen'],
      eating_tips: ['Papas Arrugadas überall günstig'],
      too_good_to_go: "Begrenzt verfügbar in Touristenzonen.",
      entry_requirements: ['Personalausweis oder Reisepass'],
      international_license_needed: false,
      medication_tips: ['Sonnencreme vorher kaufen'],
      birthday_freebies: ['Vereinzelt in Hotels']
    }
  },
  {
    id: 'elhierro',
    name: 'El Hierro',
    continent: 'Europa',
    image: 'https://images.pexels.com/photos/28588324/pexels-photo-28588324.jpeg?auto=compress&cs=tinysrgb&w=800',
    avgFlightPrice: 220,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 30, avgPrice: '€200', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 20, avgPrice: '€230', parking: 'Airparks - €42/Woche' }
    ],
    scores: { friendliness: 9.2, easyTravel: 7.0, womenSafety: 9.3, sustainability: 9.5 },
    valueScore: { internetSpeed: '40 Mbps', livingCosts: '€900/Monat', rent: '€600/Monat', nomadScore: 7.0 },
    optimalTravelTime: { best: 'März-Juni & September-November', reason: 'Kleinste Kanareninsel, perfekt für Ruhe. Ideal zum Wandern und Tauchen.' },
    weather: [
      { month: 'Jan', temp: '18°C', rain: '40mm' }, { month: 'Feb', temp: '18°C', rain: '35mm' },
      { month: 'Mär', temp: '19°C', rain: '25mm' }, { month: 'Apr', temp: '19°C', rain: '15mm' },
      { month: 'Mai', temp: '20°C', rain: '5mm' }, { month: 'Jun', temp: '21°C', rain: '2mm' },
      { month: 'Jul', temp: '23°C', rain: '1mm' }, { month: 'Aug', temp: '24°C', rain: '1mm' },
      { month: 'Sep', temp: '23°C', rain: '5mm' }, { month: 'Okt', temp: '22°C', rain: '20mm' },
      { month: 'Nov', temp: '21°C', rain: '30mm' }, { month: 'Dez', temp: '19°C', rain: '40mm' }
    ],
    transportation: [
      { type: 'Mietwagen', cost: '€30-50/Tag', speed: 'Flexibel', comfort: 'Hoch' },
      { type: 'Lokaler Bus', cost: '€5-15', speed: 'Sehr langsam', comfort: 'Niedrig' }
    ],
    noGos: ['Massentourismus erwarten', 'Hektik mitbringen', 'Natur nicht respektieren'],
    avgCosts: { coffee: '€1.50', beer: '€2.00', wine: '€3.00', water: '€1.00', localFood: '€10-18', massage: '€45', manicure: '€22', botox: '€220-320', teethWhitening: '€320-480' },
    apps: [{ name: 'Guaguas El Hierro', purpose: 'Bus-Info', affiliate: '#' }],
    travelGuides: [{ title: 'Reiseführer El Hierro', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€16.99' }],
    travel_tips: {
      highlights: ['Kleinste Kanareninsel', 'Ruhe', 'Wandern', 'Tauchen'],
      hidden_gems: ['Viele Naturwanderwege'],
      mobility_tips: ['Mietwagen empfohlen'],
      eating_tips: ['Lokale Guachinches günstig'],
      too_good_to_go: "Nicht aktiv.",
      entry_requirements: ['Personalausweis oder Reisepass'],
      international_license_needed: false,
      medication_tips: ['Sonnencreme vorher kaufen'],
      birthday_freebies: []
    }
  },
  {
    id: 'jordan',
    name: 'Jordanien',
    continent: 'Asien',
    image: 'https://images.unsplash.com/photo-1583417319070-4a69db38a482?w=800',
    avgFlightPrice: 320,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 50, avgPrice: '€300', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 35, avgPrice: '€340', parking: 'Airparks - €42/Woche' }
    ],
    scores: { friendliness: 9.2, easyTravel: 7.8, womenSafety: 7.5, sustainability: 7.0 },
    valueScore: { internetSpeed: '45 Mbps', livingCosts: '€800/Monat', rent: '€500/Monat', nomadScore: 7.2 },
    optimalTravelTime: { best: 'März-Mai & September-November', reason: 'Petra, Wadi Rum, Totes Meer. Vermeide Sommer (extrem heiß!).' },
    weather: [
      { month: 'Jan', temp: '8°C', rain: '55mm' }, { month: 'Feb', temp: '10°C', rain: '50mm' },
      { month: 'Mär', temp: '14°C', rain: '35mm' }, { month: 'Apr', temp: '19°C', rain: '15mm' },
      { month: 'Mai', temp: '24°C', rain: '5mm' }, { month: 'Jun', temp: '27°C', rain: '0mm' },
      { month: 'Jul', temp: '29°C', rain: '0mm' }, { month: 'Aug', temp: '29°C', rain: '0mm' },
      { month: 'Sep', temp: '27°C', rain: '0mm' }, { month: 'Okt', temp: '23°C', rain: '10mm' },
      { month: 'Nov', temp: '16°C', rain: '25mm' }, { month: 'Dez', temp: '10°C', rain: '45mm' }
    ],
    transportation: [
      { type: 'JETT Bus', cost: '€5-15', speed: 'Mittel', comfort: 'Mittel' },
      { type: 'Mietwagen', cost: '€30-60/Tag', speed: 'Flexibel', comfort: 'Hoch' }
    ],
    noGos: ['Israel-Thema ansprechen', 'Freizügige Kleidung', 'PDA (Public Display of Affection)'],
    avgCosts: { coffee: '€2.00', beer: '€5.00', wine: '€8.00', water: '€0.50', localFood: '€5-12', massage: '€30', manicure: '€15', botox: '€150-250', teethWhitening: '€200-350' },
    apps: [{ name: 'Careem', purpose: 'Transport', affiliate: '#' }, { name: 'Talabat', purpose: 'Food Delivery', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Jordanien', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€22.99' }],
    travel_tips: {
      highlights: ['Petra', 'Wadi Rum', 'Aqaba', 'Dead Sea', 'Amman'],
      hidden_gems: ['Dana-Biosphärenreservat'],
      mobility_tips: ['JETT Bus günstig', 'Mietwagen für Wüste'],
      eating_tips: ['Lokales Essen (Mansaf, Falafel) sehr günstig'],
      too_good_to_go: "Nicht verfügbar.",
      entry_requirements: ['Reisepass', 'E-Visa'],
      international_license_needed: false,
      medication_tips: ['Mückenschutz im Sommer', 'Sonnencreme teuer'],
      birthday_freebies: ['Amman: Einige Museen zeitweise Gratis']
    }
  },
  {
    id: 'oman',
    name: 'Oman',
    continent: 'Asien',
    image: 'https://customer-assets.emergentagent.com/job_nomad-journey-hub/artifacts/opuv1dvh_IMG_1607.JPG',
    avgFlightPrice: 350,
    optimalAirports: [
      { name: 'Frankfurt (FRA)', city: 'Frankfurt', directFlights: 60, avgPrice: '€330', parking: 'Holiday Extras - €45/Woche' },
      { name: 'München (MUC)', city: 'München', directFlights: 45, avgPrice: '€370', parking: 'Airparks - €42/Woche' }
    ],
    scores: { friendliness: 9.5, easyTravel: 8.5, womenSafety: 8.8, sustainability: 7.8 },
    valueScore: { internetSpeed: '65 Mbps', livingCosts: '€1,200/Monat', rent: '€800/Monat', nomadScore: 7.5 },
    optimalTravelTime: { best: 'Oktober-April', reason: 'Angenehmes Wetter für Wüste & Wadis. Sommer unerträglich heiß!' },
    weather: [
      { month: 'Jan', temp: '21°C', rain: '20mm' }, { month: 'Feb', temp: '22°C', rain: '15mm' },
      { month: 'Mär', temp: '26°C', rain: '10mm' }, { month: 'Apr', temp: '31°C', rain: '5mm' },
      { month: 'Mai', temp: '36°C', rain: '2mm' }, { month: 'Jun', temp: '38°C', rain: '0mm' },
      { month: 'Jul', temp: '37°C', rain: '5mm' }, { month: 'Aug', temp: '35°C', rain: '5mm' },
      { month: 'Sep', temp: '34°C', rain: '2mm' }, { month: 'Okt', temp: '31°C', rain: '2mm' },
      { month: 'Nov', temp: '27°C', rain: '5mm' }, { month: 'Dez', temp: '23°C', rain: '15mm' }
    ],
    transportation: [
      { type: 'Mietwagen (4x4)', cost: '€40-80/Tag', speed: 'Flexibel', comfort: 'Hoch' },
      { name: 'Taxi/Careem', cost: '€5-20', speed: 'Schnell', comfort: 'Hoch' }
    ],
    noGos: ['Alkohol in der Öffentlichkeit', 'Fotografieren ohne Erlaubnis', 'Unbedeckte Schultern in Moscheen'],
    avgCosts: { coffee: '€2.50', beer: '€6.00', wine: '€10.00', water: '€0.30', localFood: '€4-10', massage: '€40', manicure: '€20', botox: '€200-300', teethWhitening: '€250-400' },
    apps: [{ name: 'Careem', purpose: 'Transport', affiliate: '#' }, { name: 'Talabat', purpose: 'Food Delivery', affiliate: '#' }],
    travelGuides: [{ title: 'Lonely Planet Oman', link: 'https://www.amazon.de/s?k=Reiseführer', price: '€24.99' }],
    travel_tips: {
      highlights: ['Maskat', 'Nizwa', 'Wahiba Sands', 'Wadi Shab'],
      hidden_gems: ['Rustaq', 'Hajar-Berge'],
      mobility_tips: ['Mietwagen empfohlen'],
      eating_tips: ["Lokale 'Mataaem' günstig"],
      too_good_to_go: "Nicht aktiv.",
      entry_requirements: ['Reisepass', 'E-Visa vorab'],
      international_license_needed: false,
      medication_tips: ['Mückenschutz im Süden', 'Sonnencreme teurer'],
      birthday_freebies: ['Maskat: Hotels bieten Pakete']
    }
  }
];

// Additional flight prices for calculator
export const additionalFlightPrices = {
  switzerland: 180,
  italy: 120,
  portugal: 160,
  poland: 110,
  dubai: 380,
  india: 480,
  hongkong: 580,
  taiwan: 620
};

// Blog posts for new countries
export const blogPosts = [
  {
    id: 'blog-switzerland-1',
    countryId: 'switzerland',
    title: '10 Spartipps für die teure Schweiz',
    excerpt: 'So erlebst du die Schweiz mit kleinem Budget: Coop-Eigenmarken, Tageskarten und kostenlose Wanderungen.',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400',
    date: '2025-01-15',
    readTime: '8 min'
  },
  {
    id: 'blog-italy-1',
    countryId: 'italy',
    title: 'Geheimtipps abseits der Touristenpfade',
    excerpt: 'Entdecke authentisches Italien: Versteckte Bergdörfer, lokale Trattorias und unberührte Strände.',
    image: 'https://images.unsplash.com/photo-1523906834658-6e24ef2386f9?w=400',
    date: '2025-01-20',
    readTime: '10 min'
  },
  {
    id: 'blog-portugal-1',
    countryId: 'portugal',
    title: 'Digital Nomad Paradies Lissabon',
    excerpt: 'Warum Lissabon perfekt für Remote Work ist: Coworking Spaces, Lebenskosten und Community.',
    image: 'https://images.unsplash.com/photo-1555881400-74d7acaacd8b?w=400',
    date: '2025-02-01',
    readTime: '7 min'
  },
  {
    id: 'blog-dubai-1',
    countryId: 'dubai',
    title: 'Dubai Budget-Guide 2025',
    excerpt: 'Luxus-Destination zum kleinen Preis: Food Courts, kostenlose Attraktionen und Happy Hour Tipps.',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=400',
    date: '2025-01-28',
    readTime: '9 min'
  },
  {
    id: 'blog-india-1',
    countryId: 'india',
    title: 'Indien für Einsteiger: Survival Guide',
    excerpt: 'Dein erster Indien-Trip: Was du wissen musst über Hygiene, Transport und kulturelle Do\'s & Don\'ts.',
    image: 'https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=400',
    date: '2025-02-05',
    readTime: '12 min'
  },
  {
    id: 'blog-taiwan-1',
    countryId: 'taiwan',
    title: 'Taiwan: Asiens bestgehütetes Geheimnis',
    excerpt: 'Warum Taiwan auf deine Bucket List gehört: Nachtmärkte, Natur & die freundlichsten Menschen Asiens.',
    image: 'https://images.unsplash.com/photo-1540185408668-57f0a6a5d54f?w=400',
    date: '2025-02-10',
    readTime: '11 min'
  }
];
